import "./list.css";

const getNumerator = (type:"a"|"A"|string, i:number) => {
	switch(type){
	default:
		return String(i);
	case "a":
		return String.fromCharCode(97+i-1); // 97 == a in ASCII
	case "A":
		return String.fromCharCode(65+i-1); // 65 == A in ASCII
	}
};

const isNestedOl = (list: Element) => list.parentElement?.tagName === "LI";

const numberOl = (list: Element, prefix: string) => {
	const items = Array.from(list.children).filter((child): child is HTMLLIElement => child.tagName === "LI");
	const start = list.getAttribute("start");
	const type  = list.getAttribute("type");
	const dir   = list.getAttribute("reversed") === null ? 1 : -1;
	const lType = type === null ? "1" : type;
	let i = start === null ? 1 : parseInt(start) | 0;

	for(const item of items){
		const numerator = document.createElement("OL-NUMBER");
		const itemValue = item.getAttribute("value");
		if(itemValue){i = parseInt(itemValue);}
		const segment = prefix === "" ? getNumerator(lType, i) : String(i);
		const label = prefix === "" ? segment : `${prefix}.${segment}`;
		numerator.innerText = label;
		item.prepend(numerator);

		for(const child of item.children){
			if(child.tagName === "OL"){
				numberOl(child, label);
			}
		}

		i += dir;
	}
};

export const initOrderedLists = () => {
	// Separate ol-number elements help with styling; nested lists use hierarchical
	// decimal numbering (1.1, 1.1.1, …) instead of restarting or using letters.
	document.querySelectorAll("main ol").forEach(list => {
		if(isNestedOl(list)){return;}
		numberOl(list, "");
	});
};
setTimeout(initOrderedLists, 0);

